// @flow

const parser = new DOMParser();
const svgTags = document.querySelectorAll("img[data-svg-inline]");

svgTags.forEach((svgTag: HTMLElement) => {
    if (svgTag instanceof HTMLImageElement) {
        const imageURL = svgTag.src;
        const imageParent = svgTag.parentNode;

        fetch(imageURL)
            .then((response: Response): Promise<any> => response.text())
            .then((svgData: string) => {
                const svgDocument = parser.parseFromString(
                    svgData,
                    "image/svg+xml"
                );
                const svgElement = svgDocument.documentElement;
                if (imageParent && svgElement) {
                    svgElement.classList = svgTag.classList;
                    imageParent.replaceChild(svgElement, svgTag);
                }
            });
    }
});
